/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUsersPlus: {
  name: 'users-plus';
  data: string;
} = {
  name: 'users-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm6 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-7 8a5 5 0 0 0-5 5 1 1 0 1 1-2 0 7 7 0 0 1 11.133-5.65c1.578-.604 3.071-.432 4.272.204 1.309.692 2.245 1.923 2.565 3.204a1 1 0 1 1-1.94.485c-.18-.72-.744-1.49-1.56-1.922a2.948 2.948 0 0 0-1.728-.325A6.968 6.968 0 0 1 15 20a1 1 0 1 1-2 0 5 5 0 0 0-5-5Zm9-9a1 1 0 0 1 1-1h1V4a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V7h-1a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
